const USER_KEY = 'raheasy_user';

/** Raw JSON string from session (ephemeral) or local (persistent). Session wins if both exist. */
function readUserString() {
  return sessionStorage.getItem(USER_KEY) || localStorage.getItem(USER_KEY);
}

export function getParsedUser() {
  const raw = readUserString();
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/** Bearer token for API calls (stored inside the user JSON as `token`). */
export function getAuthToken() {
  const user = getParsedUser();
  if (user && typeof user.token === 'string' && user.token) return user.token;
  try {
    return localStorage.getItem('token');
  } catch {
    return null;
  }
}

/**
 * @param {object} payload User fields; include `token` when available
 * @param {boolean} rememberMe If true, persist in localStorage; else sessionStorage only
 */
export function persistAuthSession(payload, rememberMe) {
  const json = JSON.stringify(payload);

  if (rememberMe) {
    localStorage.setItem(USER_KEY, json);
    sessionStorage.removeItem(USER_KEY);
  } else {
    sessionStorage.setItem(USER_KEY, json);
    localStorage.removeItem(USER_KEY);
  }
  try {
    localStorage.removeItem('token');
  } catch (_) {
    /* ignore */
  }
}

export function clearAuthSession() {
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(USER_KEY);
  try {
    localStorage.removeItem('token');
  } catch (_) {
    /* ignore */
  }
}
